import type { RootState } from 'store/configureStore';

import { getGroupId } from '../session/selectors';
import type { TeamMemberWithInviteStatus } from './types';

const getScope = (state: RootState) => state.supplier;

export const getTeamMembers = (state: RootState) => {
  const teamMembers = getScope(state).teamMembers;
  const groupId = getGroupId(state);
  return teamMembers.map((teamMember) => {
    const newTeamMember: TeamMemberWithInviteStatus = { ...teamMember };
    if (teamMember.receivedInvites) {
      const invite = teamMember.receivedInvites.find(
        (invititation) => invititation.groupId === groupId,
      );
      if (invite) {
        newTeamMember.isInviteAccepted = invite.isAccepted;
        newTeamMember.isInviteExpired = invite.isExpired;
      }
    }
    return newTeamMember;
  });
};

export const getActiveTeamMember = (state: RootState) =>
  getScope(state).activeTeamMember;

export const getIsActiveTeamMemberEmailVerified = (state: RootState) =>
  getScope(state).isActiveTeamMemberEmailVerified;

export const getIsEmailResendFetching = (state: RootState) =>
  getScope(state).isEmailResendFetching;

export const isCreatingTeamMember = (state: RootState) =>
  getScope(state).isCreatingTeamMember;
